import React, { useState, useEffect, useContext } from "react"
import { ButtonGroup, Col, Form, Row, Tab, Tabs } from "react-bootstrap"
import { useNavigate, Redirect } from "react-router-dom"
import toast from "react-hot-toast"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/DataTable"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import DatePicker from "react-datepicker"
import {
  refreshPage,
  toastStyle,
  TokenExpiry,
  getType,
  numberFormat,
  selectDropdownStyle,
  formatDateNoTime,
  getTodayDate,
  getSevenDaysAgo,
} from "../../../Helpers/Utils/Common"
import Moment from "moment"
import Select from "react-select"
import AddPaymentModal from "./AddPaymentModal"
import {
  voidSalesOrder,
  deleteSalesOrder,
  getSalesOrder,
} from "../../../Helpers/apiCalls/SalesModule/SalesOrderApi"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import { getAllBranches } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import SOModal from "./Component/SOModal"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function SalesOrder() {
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)
  let navigate = useNavigate()
  const userType = getType()
  const [inactive, setInactive] = useState(true)
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [excelData, setExcelData] = useState([])
  const [tableData, setTableData] = useState([])
  // const [balance, setBalance] = useState("")
  const [selectedRow, setSelectedRow] = useState({})
  const [summary, setSummary] = useState({})
  // const xlsxHeaders = [
  //   "BRANCH NAME",
  //   "FRANCHISEE",
  //   "PACKAGE",
  //   "TOTAL",
  //   "PAID AMOUNT",
  //   "BALANCE",
  //   "CREDIT LIMIT",
  //   "OPEN DATE",
  //   "CNTRCT END",
  //   "IS EXPIRED",
  // ]
  const [customers, setCustomers] = useState([])
  const [branches, setBranches] = useState([])
  const [reason, setReason] = useState("")

  /* FILTER CONFIGS */
  const [filterConfig, setFilterConfig] = useState({
    franchise: "",
    tab: currentTab ? currentTab : "pending",
    status: currentTab ? currentTab : "pending",
    payment_status: "",
    franchised_on_from: "",
    franchised_on_to: "",
    page: 1,
    // date_from: getSevenDaysAgo(),
    // date_to: getTodayDate(),
    with_invoice: "all",
    inv_name: "All Invoices",
    invoice_id_value: {
      label: "All Invoices",
      value: "all",
    },
    date_from:
      dateFilter.date_from !== "" ? dateFilter.date_from : getSevenDaysAgo(),
    date_to: dateFilter.date_to !== "" ? dateFilter.date_to : getTodayDate(),
  })

  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  const options = [
    {
      id: 0,
      label: "All Invoices",
      value: "all",
    },
    {
      id: 1,
      label: "With Invoice",
      value: "yes",
    },
    {
      id: 2,
      label: "No Invoice",
      value: "no",
    },
  ]

  function handleFilterChange(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        status: tabKey,
        branch_id: "",
        branch_id_value: {
          label: "All Branches",
          value: "",
        },
        page: 1,
        customer_id: "",
        anything: "",
        customer_id_value: {
          label: "All Customer",
          value: "",
        },
        with_invoice: "all",
        inv_name: "All Invoices",
        invoice_id_value: {
          label: "All Invoices",
          id: "",
        },
      }
    })
  }

  async function fetchData() {
    setShowLoader(true)
    setTableData([])
    setExcelData([])
    setTotalItems(0)

    const response = await getSalesOrder(filterConfig)

    if (response.data) {
      const summaryEntries = Object.entries(response.data.summary)
      const summaryObject = Object.fromEntries(summaryEntries)
      setSummary(summaryObject)

      var sortedData = response.data.data.sort((a, b) =>
        a.branch_name > b.branch_name
          ? 1
          : b.branch_name > a.branch_name
          ? -1
          : 0
      )

      var allBills = sortedData.map((data) => {
        var info = data
        info.added_on =
          data.added_on !== "0000-00-00"
            ? Moment(data.delivery_date).format("MMM DD, YYYY")
            : "None"
        info.delivery_date =
          data.delivery_date !== "0000-00-00"
            ? Moment(data.delivery_date).format("MMM DD, YYYY")
            : "None"
        info.doc_no = data.id
        info.customer_name = data.customer_name
        info.branch_name = data.branch_name
        info.grand_total = numberFormat(info.grand_total)
        info.subtotal = numberFormat(info.subtotal)
        info.discount = numberFormat(info.discount)
        info.paid_amount = info.paid_amount
          ? numberFormat(info.paid_amount)
          : "0.00"
        info.balance = numberFormat(info.balance)
        info.status = data.status
        return info
      })
      setTableData(allBills)

      var excel = allBills.map((bill) => {
        var info = {}
        info.added_on = bill.added_on
        info.delivery_date = bill.delivery_date
        info.doc_no = bill.doc_no
        info.customer_name = bill.customer_name
        info.branch_name = bill.branch_name
        info.grand_total = bill.grand_total
        info.status = bill.status
        return info
      })
      setExcelData(excel)
      setTotalItems(response.data.size)
    } else if (response.error) {
      setSummary(0)
      TokenExpiry(response)
    }
    setShowLoader(false)
  }

  // function handleExport() {
  //   const rows = excelData
  //   const worksheet = XLSX.utils.json_to_sheet(rows)
  //   const workbook = XLSX.utils.book_new()
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
  //   XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
  //   XLSX.writeFile(workbook, "Franchise.xlsx", { compression: true })
  // }

  async function fetchBranches() {
    setBranches([])
    const response = await getAllBranches()

    if (response.data) {
      let result = response.data.data.map((data) => {
        var info = data
        info.label = data.name
        info.value = data.id
        info.var_name = "branch_id"
        return info
      })
      setBranches([{ label: "All Branches", value: "" }, ...result])
    }
  }

  async function fetchCustomers() {
    setShowLoader(true)

    const response = await getCustomer({})

    if (response.error) {
      TokenExpiry(response.error)
    } else {
      var data = response.data.data.map((data) => {
        var info = data
        info.label = data.trade_name
        info.value = data.id
        info.var_name = "customer_id"
        return info
      })
      setCustomers([{ label: "All Customers", value: "" }, ...data])
    }
    setShowLoader(false)
  }

  /* add payment modal handler */
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false)
  const handleShowAddPaymentModal = () => setShowAddPaymentModal(true)
  const handleCloseAddPaymentModal = () => setShowAddPaymentModal(false)
  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  // void modal handler
  const [showVoidModal, setShowVoidModal] = useState(false)
  const handleShowVoidModal = () => setShowVoidModal(true)
  const handleCloseVoidModal = () => setShowVoidModal(false)

  async function handleDeleteSalesOrder() {
    setIsClicked(true)
    const response = await deleteSalesOrder(selectedRow.id)

    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
  }

  const handleVoid = (reason) => {
    setReason(reason)
    handleVoidSalesOrder(reason)
  }

  async function handleVoidSalesOrder(reason) {
    setIsClicked(true)
    const response = await voidSalesOrder(selectedRow.id, reason)

    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row)
    if (e.target.value === "edit") {
      navigate("edit/" + row.id)
    } else if (e.target.value === "print") {
      navigate("print/" + row.id)
    } else if (e.target.value === "delete") {
      handleShowDeleteModal()
    } else if (e.target.value === "void") {
      handleShowVoidModal()
    }
  }

  function ViewPIBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row)}
        value="print"
      >
        View
      </button>
    )
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        <option value="print" className="color-options">
          View
        </option>
        <option value="print" className="color-options">
          Print
        </option>
        {(userType === "admin" || userType === "wholesale_head") &&
          filterConfig.tab === "pending" && (
            <option value="edit" className="color-options">
              Edit
            </option>
          )}
        {(userType === "admin" || userType === "wholesale_head") &&
          filterConfig.tab === "completed" && (
            <option value="void" className="color-options">
              Void Order
            </option>
          )}
        {(userType === "admin" || userType === "wholesale_head") && (
          <option value="delete" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  function ViewBtn(row) {
    return (
      <button
        type="button"
        className="button-primary table-button"
        onClick={(e) => handleViewBtn(row.id)}
      >
        Create Invoice
      </button>
    )
  }

  function handleViewBtn(id) {
    // navigate("wholesaleinvoice/add/" + id);
    window.location.href = "wholesaleinvoice/add/" + id
  }

  function PmtRefBtn(row) {
    return (
      <ButtonGroup vertical>
        <>
          {row.payments?.map((row) => {
            return (
              <button
                type="button"
                className="button-secondary table-button me-3 mt-1"
                onClick={() => handleViewPmt(row.id, row.payment_mode)}
              >
                {row.doc_no}
              </button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }
  function handleViewPmt(id, payment_mode) {
    // navigate("/purchaseinvoices/print/" + id);
    navigate("/salespayment/view/" + id + "/" + payment_mode)
  }

  function SalesInvBtn(row) {
    if (row.invoice_ids) {
      return (
        <ButtonGroup vertical>
          <>
            {row.invoice_ids?.map((row) => {
              return (
                <button
                  type="button"
                  className="button-secondary table-button p-1"
                  onClick={() => handleViewSalesInvoice(row)}
                >
                  {`NO.${row}`}
                </button>
              )
            })}
          </>
        </ButtonGroup>
      )
    }
  }
  function handleViewSalesInvoice(id) {
    window.open("/wholesaleinvoice/print/" + id, "_blank")
  }

  useEffect(() => {
    fetchBranches()
  }, [])

  useEffect(() => {
    fetchCustomers()
  }, [])

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SALES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              SALES ORDER{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              placeholder="Search..."
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
              className="search-bar"
            />
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                className="add-btn"
                onClick={() => navigate("/salesorder/add")}
              >
                Add
              </button>
            </div>
          </Col>
        </Row>
        {/* <Row>
                    <Col className="d-flex justify-content-end mb-4">
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleExport}
                            >
                                <span className="me-2">
                                    <img
                                        alt="download"
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                Download
                            </button>
                        </div>
                    </Col>
                </Row> */}

        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          className="mt-3 mt-md-5 PO-tabs"
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="pending" title="pending" className="__table-container">
            <p className="mt-3 m-0 d-none d-md-flex w-full">FILTER BY:</p>
            <Row className="PO-filters">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.inv_name}
                  value={filterConfig.with_invoice}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                {/* <Form.Control
                  type="date"
                  name="date_from"
                  className="nc-modal-custom-text"
                  placeholder={filterConfig.date_from}
                  // onChange={(e) => handleAddChange(e)}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date.timeStamp }
                    })
                  }}
                /> */}
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  // placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  // placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Subtotal:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Discount:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_discount)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
              </span>
            </div>
            {/* table */}
            {/* filters */}
            {/* <Row>
                            <Col>
                                <div className="my-2 px-4 PO-filters d-flex flex-row gap-2 mb-2 filter flex-column">
                                    <span className="me-4 align-middle d-none d-md-inline mt-2">
                                        Filter By:
                                    </span>
                                    <div className="row flex">
                                        <div className="col-lg-3 col-md-6 col-sm-6">
                                            <Select
                                                className="dropsearch-filter px-0 py-0 me-2"
                                                classNamePrefix="react-select"
                                                placeholder="Select Branch"
                                                styles={selectDropdownStyle}
                                                value={filterConfig.branch_id_value}
                                                options={branches}
                                                onChange={(e) => {
                                                    setFilterConfig((prev) => {
                                                        return { ...prev, 
                                                            [e.var_name]: e.value,
                                                            branch_id_value: {
                                                                label: e.label,
                                                                value: e.value,
                                                            }
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    
                                </div>

                            </Col>
                        </Row> */}
            <div className="mb-2" />
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ORDER DATE",
                "DLVRY DATE",
                "INV. NO",
                "CUSTOMER",
                "BRANCH",
                "SUBTOTAL",
                "DISCOUNT",
                "AMOUNT DUE",
                // "AMOUNT PAID",
                // "BALANCE",
                // "SALES INVOICES",
                // "PMT REF NO",
                "STATUS",
                "DOC. NO",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "added_on",
                "delivery_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "subtotal",
                "discount",
                "grand_total",
                // "paid_amount",
                // "balance",
                // "sales_invoice",
                // "pmt_ref_no",
                "status",
                "id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewBtn(row)}
              newTabBtn={(row) => PmtRefBtn(row)}
              PendingBtn={(row) => SalesInvBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              showLoader={showLoader}
              withActionData={false}
            />
            <div className="mb-2" />
          </Tab>
          <Tab
            eventKey="incomplete"
            title="incomplete"
            className="__table-container"
          >
            <p className=" mt-3 m-0 d-none d-md-flex w-full">FILTER BY:</p>
            <Row className="PO-filters">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.invoice_id_value.label}
                  value={filterConfig.invoice_id_value.value}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Subtotal:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Discount:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_discount)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
              </span>
            </div>
            {/* <Row>
                            <Col>
                                <div className="my-2 px-4 PO-filters d-flex flex-row gap-2 filter flex-column">
                                    <span className="me-4 align-middle d-none d-md-inline mt-2">Filter By:</span>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 col-sm-6">
                                            <Select
                                                className="dropsearch-filter px-0 py-0 me-2"
                                                classNamePrefix="react-select"
                                                placeholder="Select Branch"
                                                styles={selectDropdownStyle}
                                                value={filterConfig.branch_id_value}
                                                options={branches}
                                                onChange={(e) => {
                                                    setFilterConfig((prev) => {
                                                        return { ...prev, 
                                                            [e.var_name]: e.value,
                                                            branch_id_value: {
                                                                label: e.label,
                                                                value: e.value,
                                                            }
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>

                        </Row> */}
            <div className="mb-2" />
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ORDER DATE",
                "DLVRY DATE",
                "INV. NO",
                "CUSTOMER",
                "BRANCH",
                "SUBTOTAL",
                "DISCOUNT",
                "AMOUNT DUE",
                // "AMOUNT PAID",
                // "BALANCE",
                "SALES INVOICES",
                // "PMT REF NO",
                "STATUS",
                "DOC. NO",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "added_on",
                "delivery_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "subtotal",
                "discount",
                "grand_total",
                // "paid_amount",
                // "balance",
                "sales_invoice",
                // "pmt_ref_no",
                "status",
                "id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewBtn(row)}
              newTabBtn={(row) => PmtRefBtn(row)}
              PendingBtn={(row) => SalesInvBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              showLoader={showLoader}
              withActionData={false}
            />
            <div className="mb-2" />
          </Tab>
          <Tab
            eventKey="completed"
            title="completed"
            className="__table-container"
          >
            <p className="mt-3 m-0 d-none d-md-flex w-full">FILTER BY:</p>
            <Row className="PO-filters">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.inv_name}
                  value={filterConfig.invoice}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Subtotal:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Discount:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_discount)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
              </span>
            </div>
            {/* <Row>
                            <Col>
                                <div className="my-2 px-4 PO-filters d-flex flex-row gap-2 filter flex-column">
                                    <span className="me-4 align-middle d-none d-md-inline mt-2">Filter By:</span>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 col-sm-6">
                                            <Select
                                                className="dropsearch-filter px-0 py-0 me-2"
                                                classNamePrefix="react-select"
                                                placeholder="Select Branch"
                                                styles={selectDropdownStyle}
                                                value={filterConfig.branch_id_value}
                                                options={branches}
                                                onChange={(e) => {
                                                    setFilterConfig((prev) => {
                                                        return { ...prev, 
                                                            [e.var_name]: e.value,
                                                            branch_id_value: {
                                                                label: e.label,
                                                                value: e.value,
                                                            }
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row> */}
            {/* <Row>
                            <Col>
                                <div className="my-2 px-4 PO-filters d-flex flex-row gap-2 mb-2 filter flex-column">
                                    <span className="me-4 align-middle d-none d-md-inline mt-2">Filter By:</span>
                                    <div className="row flex">
                                        <div className="col-lg-3 col-md-6 col-sm-6">
                                            <Select
                                                className="dropsearch-filter px-0 py-0 me-2"
                                                classNamePrefix="react-select"
                                                placeholder="Select Customer"
                                                styles={selectDropdownStyle}
                                                value={filterConfig.customer_id_value}
                                                options={customers}
                                                onChange={(e) => {
                                                    setFilterConfig((prev) => {
                                                        return { ...prev, 
                                                            [e.var_name]: e.value,
                                                            customer_id_value: {
                                                                label: e.label,
                                                                value: e.value,
                                                            }
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </Col>
                        </Row> */}
            <div className="mb-2" />
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ORDER DATE",
                "DLVRY DATE",
                "INV. NO",
                "CUSTOMER",
                "BRANCH",
                "SUBTOTAL",
                "DISCOUNT",
                "AMOUNT DUE",
                // "AMOUNT PAID",
                // "BALANCE",
                "SALES INVOICES",
                // "PMT REF NO",
                "STATUS",
                "DOC. NO",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "added_on",
                "delivery_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "subtotal",
                "discount",
                "grand_total",
                // "paid_amount",
                // "balance",
                "sales_invoice",
                // "pmt_ref_no",
                "status",
                "id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewPIBtn(row)}
              newTabBtn={(row) => PmtRefBtn(row)}
              PendingBtn={(row) => SalesInvBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              showLoader={showLoader}
              withActionData={false}
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="voided" title="voided" className="__table-container">
            <p className="mt-3 m-0 d-none d-md-flex w-full">FILTER BY:</p>
            <Row className="PO-filters">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.inv_name}
                  value={filterConfig.invoice}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Subtotal:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Discount:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_discount)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
              </span>
            </div>
            {/* <Row>
                            <Col>
                                <div className="my-2 px-4 PO-filters d-flex flex-row gap-2 filter flex-column">
                                    <span className="me-4 align-middle d-none d-md-inline mt-2">Filter By:</span>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 col-sm-6">
                                            <Select
                                                className="dropsearch-filter px-0 py-0 me-2"
                                                classNamePrefix="react-select"
                                                placeholder="Select Branch"
                                                styles={selectDropdownStyle}
                                                value={filterConfig.branch_id_value}
                                                options={branches}
                                                onChange={(e) => {
                                                    setFilterConfig((prev) => {
                                                        return { ...prev, 
                                                            [e.var_name]: e.value,
                                                            branch_id_value: {
                                                                label: e.label,
                                                                value: e.value,
                                                            }
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>

                        </Row> */}
            <div className="mb-2" />
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ORDER DATE",
                "DLVRY DATE",
                "INV. NO",
                "CUSTOMER",
                "BRANCH",
                "SUBTOTAL",
                "DISCOUNT",
                "AMOUNT DUE",
                // "AMOUNT PAID",
                // "BALANCE",
                // "SALES INVOICES",
                // "PMT REF NO",
                "STATUS",
                "DOC. NO",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "added_on",
                "delivery_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "subtotal",
                "discount",
                "grand_total",
                // "paid_amount",
                // "balance",
                // "sales_invoice",
                // "pmt_ref_no",
                "status",
                "id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewPIBtn(row)}
              newTabBtn={(row) => PmtRefBtn(row)}
              PendingBtn={(row) => SalesInvBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              showLoader={showLoader}
              withActionData={false}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="all" title="all" className="__table-container">
            <p className="mt-3 m-0 d-none d-md-flex w-full">FILTER BY:</p>
            <Row className="PO-filters">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.inv_name}
                  value={filterConfig.invoice}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Subtotal:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Total Discount:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.total_discount)}
              </span>
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due:{" "}
                {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
              </span>
            </div>
            <div className="mb-2" />
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "ORDER DATE",
                "DLVRY DATE",
                "INV. NO",
                "CUSTOMER",
                "BRANCH",
                "SUBTOTAL",
                "DISCOUNT",
                "AMOUNT DUE",
                // "AMOUNT PAID",
                // "BALANCE",
                "SALES INVOICES",
                // "PMT REF NO",
                "STATUS",
                "DOC. NO",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "added_on",
                "delivery_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "subtotal",
                "discount",
                "grand_total",
                // "paid_amount",
                // "balance",
                "sales_invoice",
                // "pmt_ref_no",
                "status",
                "id",
              ]}
              // tableData={tableData.filter(item => item.status !== 'voided')}
              tableData={tableData}
              ViewBtn={(row) => ViewPIBtn(row)}
              newTabBtn={(row) => PmtRefBtn(row)}
              PendingBtn={(row) => SalesInvBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              showLoader={showLoader}
              withActionData={false}
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="Sales Order"
        onDelete={() => handleDeleteSalesOrder()}
        isClicked={isClicked}
      />
      <AddPaymentModal
        id={selectedRow.id}
        balance={selectedRow.balance}
        franchiseeID={selectedRow.franchisee_id}
        show={showAddPaymentModal}
        onHide={handleCloseAddPaymentModal}
      />
      <SOModal
        show={showVoidModal}
        hide={() => handleCloseVoidModal()}
        message="Are you sure you want to void this sales order?"
        onDelete={handleVoid}
        // handler={() => handleVoidSalesOrder()}
        isClicked={isClicked}
      />
      <Footer />
    </div>
  )
}
